var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokingYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.65,
    height: 26.182,
    viewBox: "0 0 34.65 26.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Smoker",
    transform: "translate(-461.541 -458.376)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_75",
    "data-name": "Rechteck 75",
    width: 1.544,
    height: 5.293,
    transform: "translate(492.209 478.764)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_1",
    "data-name": "Vereinigungsmenge 1",
    d: "M28.069,6.749H0V0H29.774V6.749Z",
    transform: "translate(462.041 477.309)",
    fill: "#454545",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_76",
    "data-name": "Rechteck 76",
    width: 1.544,
    height: 5.293,
    transform: "translate(494.635 478.764)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_654",
    "data-name": "Pfad 654",
    d: "M2234.637,1014.968a7.433,7.433,0,0,0-.937-2.955,7.24,7.24,0,0,0-2.033-2.277,6.612,6.612,0,0,0-2.407-1.072,13.206,13.206,0,0,0-2.731-.084,8.233,8.233,0,0,0,.376-1.276,5.437,5.437,0,0,0,.083-2.544,4.915,4.915,0,0,0-1.763-2.667,5.649,5.649,0,0,0-3.63-1.232.772.772,0,0,0,.021,1.544,4.106,4.106,0,0,1,2.634.885,3.441,3.441,0,0,1,1.237,1.832,4.013,4.013,0,0,1-.093,1.867,6.718,6.718,0,0,1-.755,1.979.773.773,0,0,0,.089.894.792.792,0,0,0,.6.263c1.88,0,3.826-.273,5.45.873a5.652,5.652,0,0,1,1.583,1.781,5.885,5.885,0,0,1,.737,2.308l.055,3.651,1.544-.023-.056-3.683C2234.64,1015.01,2234.639,1014.989,2234.637,1014.968Z",
    transform: "translate(-1738.505 -540.808)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_655",
    "data-name": "Pfad 655",
    d: "M1925.218,922.892a4.184,4.184,0,0,0-2.993-1.534h-5.375a2.127,2.127,0,0,1-1.152-.539,2.318,2.318,0,0,1-.649-1.448,3.142,3.142,0,0,1,.286-1.805.773.773,0,0,0-.161-.888.781.781,0,0,0-.519-.216,5.311,5.311,0,0,1-1.493-.269,3.887,3.887,0,0,1-2.239-1.488,3.616,3.616,0,0,1-.189-3.038,3.078,3.078,0,0,1,1.3-1.752,2.827,2.827,0,0,1,1.49-.378h0a.772.772,0,0,0,.786-.757h0a.772.772,0,0,0-.757-.786h0a4.358,4.358,0,0,0-2.3.593,4.606,4.606,0,0,0-1.968,2.571,5.146,5.146,0,0,0,.34,4.372,5.353,5.353,0,0,0,3.054,2.128,6.811,6.811,0,0,0,.921.238,4.554,4.554,0,0,0-.072,1.7,3.841,3.841,0,0,0,1.115,2.345,3.675,3.675,0,0,0,2.074.956.754.754,0,0,0,.089.005h5.356a2.6,2.6,0,0,1,1.841.935,2.373,2.373,0,0,1,.457,1.084v2.525H1926v-2.58a.779.779,0,0,0-.006-.1A3.921,3.921,0,0,0,1925.218,922.892Z",
    transform: "translate(-1432.244 -449.615)",
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokingYes);
export default __webpack_public_path__ + "static/media/smoking-yes.1f103c0049d2948514bf1be4b01e2f40.svg";
export { ForwardRef as ReactComponent };